import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Algorithm for choosing between ride providers.
 */
export const schema = z.string();

export type RideProviderAlgorithmKey = z.infer<typeof schema>;

export const definition = define({
  key: 'ride_provider_algorithm_key',
  schema,
  label: 'Ride Provider Selection Algorithm',
  description:
    'Select the algorithm when choosing between ride providers. Each algorithm has different selection criteria and logic.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.RIDESHARE.key,
  writableAtLevels: [
    LEVELS.REGION,
    LEVELS.ORGANIZATION,
    LEVELS.CUSTOMER,
    LEVELS.WORKFLOWSET,
    LEVELS.RATERULEGROUP,
    LEVELS.MOVE,
  ],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: 'ride-provider-cheapest-v1',

  storage: {
    enum: {
      from: 'algorithms',
      select: {
        key: true,
        label: true,
        description: true,
        params: true,
      },
      where: {
        type: { _eq: 'ride-provider-selection' },
      },
      orderBy: { key: 'asc' },
      mapping: {
        value: 'key',
        label: 'label',
        description: 'description',
        metadata: {
          params: 'params',
        },
      },
    },
    // Default JSONB storage in config column - no levels config needed
  },
});
